/**
 * 全局混合
 */
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PostRes } from '@/store/pages/report/index.d';
import { dateFormate, fetchReportAfterRecovery } from '@/utils/report';
import CommonMixin from '@/mixins/common.mixin';
const Report = namespace('report');

@Component
export default class Level extends CommonMixin {
  @Report.Action('getMonthlyIncomeReport') private getMonthlyIncomeReport: any;
  @Report.Action('exportMonthlyIncomeReport') private exportMonthlyIncomeReport: any;
  @Report.Action('recoveryMonthlyIncomeReport') private recoveryMonthlyIncomeReport: any;
  public exportReport() {
    this.exportMonthlyIncomeReport({
      reportId: this.reportId, 
      level: this.level, 
      start_date: dateFormate(this.start),  
      end_date: dateFormate(this.end), 
      store_group_id: this.store_group_id
    });
  }
  public recovery() {
    this.recoveryMonthlyIncomeReport({reportId: this.reportId, level: this.level}).then((res: PostRes) => {
      this.fetchReport();
    });
  }
  public fetchReport() {
    fetchReportAfterRecovery(this, 'getMonthlyIncomeReport');
  }
}
